const CountryList = [
  { Code: 'Afghanistan' },
  { Code: 'Albania' },
  { Code: 'Algeria' },
  { Code: 'Andorra' },
  { Code: 'Angola' },
  { Code: 'Antigua and Barbuda' },
  { Code: 'Argentina' },
  { Code: 'Armenia' },
  { Code: 'Australia' },
  { Code: 'Austria' },
  { Code: 'Azerbaijan' },
  { Code: 'Bahamas' },
  { Code: 'Bahrain' },
  { Code: 'Bangladesh' },
  { Code: 'Barbados' },
  { Code: 'Belarus' },
  { Code: 'Belgium' },
  { Code: 'Belize' },
  { Code: 'Benin' },
  { Code: 'Bhutan' },
  { Code: 'Bolivia (Plurinational State of)' },
  { Code: 'Bosnia and Herzegovina' },
  { Code: 'Botswana' },
  { Code: 'Brazil' },
  { Code: 'Brunei Darussalam' },
  { Code: 'Bulgaria' },
  { Code: 'Burkina Faso' },
  { Code: 'Burundi' },
  { Code: 'Cabo Verde' },
  { Code: 'Cambodia' },
  { Code: 'Cameroon' },
  { Code: 'Canada' },
  { Code: 'Central African Rep.' },
  { Code: 'Chad' },
  { Code: 'Chile' },
  { Code: 'China' },
  { Code: 'Colombia' },
  { Code: 'Comoros' },
  { Code: 'Congo (Rep. of the)' },
  { Code: 'Costa Rica' },
  { Code: 'Croatia' },
  { Code: 'Cuba' },
  { Code: 'Cyprus' },
  { Code: 'Czech Republic' },
  { Code: "Côte d'Ivoire" },
  { Code: "Dem. People's Rep. of Korea" },
  { Code: 'Dem. Rep. of the Congo' },
  { Code: 'Denmark' },
  { Code: 'Djibouti' },
  { Code: 'Dominica' },
  { Code: 'Dominican Rep.' },
  { Code: 'Ecuador' },
  { Code: 'Egypt' },
  { Code: 'El Salvador' },
  { Code: 'Equatorial Guinea' },
  { Code: 'Eritrea' },
  { Code: 'Estonia' },
  { Code: 'Eswatini' },
  { Code: 'Ethiopia' },
  { Code: 'Fiji' },
  { Code: 'Finland' },
  { Code: 'France' },
  { Code: 'Gabon' },
  { Code: 'Gambia' },
  { Code: 'Georgia' },
  { Code: 'Germany' },
  { Code: 'Ghana' },
  { Code: 'Greece' },
  { Code: 'Grenada' },
  { Code: 'Guatemala' },
  { Code: 'Guinea' },
  { Code: 'Guinea-Bissau' },
  { Code: 'Guyana' },
  { Code: 'Haiti' },
  { Code: 'Honduras' },
  { Code: 'Hungary' },
  { Code: 'Iceland' },
  { Code: 'India' },
  { Code: 'Indonesia' },
  { Code: 'Iran (Islamic Republic of)' },
  { Code: 'Iraq' },
  { Code: 'Ireland' },
  { Code: 'Israel' },
  { Code: 'Italy' },
  { Code: 'Jamaica' },
  { Code: 'Japan' },
  { Code: 'Jordan' },
  { Code: 'Kazakhstan' },
  { Code: 'Kenya' },
  { Code: 'Kiribati' },
  { Code: 'Korea (Rep. of)' },
  { Code: 'Kuwait' },
  { Code: 'Kyrgyzstan' },
  { Code: 'Lao P.D.R.' },
  { Code: 'Latvia' },
  { Code: 'Lebanon' },
  { Code: 'Lesotho' },
  { Code: 'Liberia' },
  { Code: 'Libya' },
  { Code: 'Liechtenstein' },
  { Code: 'Lithuania' },
  { Code: 'Luxembourg' },
  { Code: 'Madagascar' },
  { Code: 'Malawi' },
  { Code: 'Malaysia' },
  { Code: 'Maldives' },
  { Code: 'Mali' },
  { Code: 'Malta' },
  { Code: 'Marshall Islands' },
  { Code: 'Mauritania' },
  { Code: 'Mauritius' },
  { Code: 'Mexico' },
  { Code: 'Micronesia' },
  { Code: 'Moldova' },
  { Code: 'Monaco' },
  { Code: 'Mongolia' },
  { Code: 'Montenegro' },
  { Code: 'Morocco' },
  { Code: 'Mozambique' },
  { Code: 'Myanmar' },
  { Code: 'Namibia' },
  { Code: 'Nauru' },
  { Code: 'Nepal' },
  { Code: 'Netherlands' },
  { Code: 'New Zealand' },
  { Code: 'Nicaragua' },
  { Code: 'Niger' },
  { Code: 'Nigeria' },
  { Code: 'North Macedonia' },
  { Code: 'Norway' },
  { Code: 'Oman' },
  { Code: 'Pakistan' },
  { Code: 'Panama' },
  { Code: 'Papua New Guinea' },
  { Code: 'Paraguay' },
  { Code: 'Peru' },
  { Code: 'Philippines' },
  { Code: 'Poland' },
  { Code: 'Portugal' },
  { Code: 'Qatar' },
  { Code: 'Romania' },
  { Code: 'Russian Federation' },
  { Code: 'Rwanda' },
  { Code: 'Saint Kitts and Nevis' },
  { Code: 'Saint Lucia' },
  { Code: 'Saint Vincent and the Grenadines' },
  { Code: 'Samoa' },
  { Code: 'San Marino' },
  { Code: 'Sao Tome and Principe' },
  { Code: 'Saudi Arabia' },
  { Code: 'Senegal' },
  { Code: 'Serbia' },
  { Code: 'Seychelles' },
  { Code: 'Sierra Leone' },
  { Code: 'Singapore' },
  { Code: 'Slovakia' },
  { Code: 'Slovenia' },
  { Code: 'Solomon Islands' },
  { Code: 'Somalia' },
  { Code: 'South Africa' },
  { Code: 'South Sudan' },
  { Code: 'Spain' },
  { Code: 'Sri Lanka' },
  { Code: 'State of Palestine / Resolution 99' },
  { Code: 'Sudan' },
  { Code: 'Suriname' },
  { Code: 'Sweden' },
  { Code: 'Switzerland' },
  { Code: 'Syrian Arab Republic' },
  { Code: 'Tajikistan' },
  { Code: 'Tanzania' },
  { Code: 'Thailand' },
  { Code: 'Timor-Leste' },
  { Code: 'Togo' },
  { Code: 'Tonga' },
  { Code: 'Trinidad and Tobago' },
  { Code: 'Tunisia' },
  { Code: 'Türkiye' },
  { Code: 'Turkmenistan' },
  { Code: 'Tuvalu' },
  { Code: 'Uganda' },
  { Code: 'Ukraine' },
  { Code: 'United Arab Emirates' },
  { Code: 'United Kingdom' },
  { Code: 'United States' },
  { Code: 'Uruguay' },
  { Code: 'Uzbekistan' },
  { Code: 'Vanuatu' },
  { Code: 'Vatican' },
  { Code: 'Venezuela' },
  { Code: 'Viet Nam' },
  { Code: 'Yemen' },
  { Code: 'Zambia' },
  { Code: 'Zimbabwe' },
];
export default CountryList;
